import React from "react";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "qr-view",
    path: `/devotee-qr/:devoteeId`,
    component: React.lazy(() => import("views/devotee-qr-view")),
  },
];

export const protectedRoutes = [
  {
    key: "devotee-log",
    path: `/devotee-log`,
    component: React.lazy(() => import("views/devotee-log")),
  },
  {
    key: "available",
    path: `/available`,
    component: React.lazy(() => import("views/available-seats")),
  },
  {
    key: "add-devotee",
    path: `/add-devotee`,
    component: React.lazy(() => import("views/add-devotee")),
  },
  {
    key: "add-table",
    path: `/add-table`,
    component: React.lazy(() => import("views/add-table")),
  },
  {
    key: "print-cards",
    path: "/print-cards",
    component: React.lazy(() =>
      import("views/devotee-log/components/PrintTicketPage")
    ),
  },
  {
    key: "not-found",
    path: "/not-found",
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];
